import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { TextField, MenuItem, Button } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  input: {
    width: "100%",
  },
  margin: {
    marginBottom: "40px",
  },
  pagination: {
    "& .MuiTextField-root": {
      width: "35px",
      minWidth: "auto",
    },
    "& .MuiSelect-root": {
      paddingTop: "3px",
      paddingBottom: "3px",
    },
    "& input": {
      padding: "4px 0px !important",
      marginLeft: "10px",
      marginRight: "10px",
    },
    "& button": {
      background: "white",
      color: "#cccccc",
      border: "1px solid #CCCCCC",
      minWidth: "auto",
      width: "24px",
      height: "24px",
      margin: "4px 0",
      "&.left": {
        borderRadius: "4px 0 0 4px",
        marginLeft: "10px",
      },
      "&.right": {
        borderRadius: " 0 4px 4px 0",
      },
    },
  },
}));

export default function PaginationBar({
  pageSize,
  setPageSize,
  gotoPage,
  previousPage,
  nextPage,
  canPreviousPage,
  canNextPage,
  pageIndex,
  totalCount
}) {

  const classes = useStyles();
  const handlePageSizeChange = (e) => {
    setPageSize(Number(e.target.value));
  }

  return (
    <div className={classes.pagination}>
      Show rows:{" "}
      <TextField
        id="page-rows"
        select
        value={pageSize}
        onChange={handlePageSizeChange}
        variant="outlined"
        style={{ minWidth: "70px" }}
      >
        {[5, 10, 25, 9999999].map((pageSize) => (
          <MenuItem key={pageSize} value={pageSize}>
            {pageSize === 9999999 ? "All" : pageSize}
          </MenuItem>
        ))}
      </TextField>
      Go to{" "}
      <TextField
        id="pagination-field"
        variant="outlined"
        onChange={(e) => {
          const page = e.target.value ? Number(e.target.value) - 1 : 0;
          gotoPage(page);
        }}
      />
      {pageIndex * pageSize + 1} to{" "}
      {(pageIndex + 1) * pageSize > totalCount
        ? totalCount
        : (pageIndex + 1) * pageSize}{" "}
      of {totalCount}
      <Button
        onClick={() => previousPage()}
        disabled={!canPreviousPage}
        className="left"
      >
        {"<"}
      </Button>
      <Button
        onClick={() => nextPage()}
        disabled={!canNextPage}
        className="right"
      >
        {">"}
      </Button>
    </div>
  );
}
